var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"society-container flex flex-col justify-around"},[_c('img',{staticClass:"logo mx-auto py-8",attrs:{"src":require("../assets/logos/louisxiii-white.svg"),"alt":""}}),_c('SocietyText',{attrs:{"delay":3}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }